import React from 'react';

import withAppState from '../mobx/withAppState';
import SwipeableContainer from '../components/Swipeable';

class Modal extends React.Component {
  handleModalCancel = () => {
    this.props.disableMainModal();
  }

  handleModalConfirm = () => {
    this.props.mainModalCTA();
    this.props.disableMainModal();
  }

  render() {
    return (
      <>
      <div className={`modal-slide-bg ${(this.props.modalActive === true) ? 'active' : ''}`} onClick={() => { this.handleModalCancel() }}></div>
      <SwipeableContainer handleModalCancel={() => this.handleModalCancel()} slideUpModal={this.props.modalActive}>
        <div ref={this.setWrapperRef} className="error-modal-inner">
          <div className="modal-slide-up-content">
            <div className="modal-content-inner">
              <div className="modal-pop-up">
              <div className={`modal-header has-background-icon`}>
                <h3>{this.props.modalTitle ? this.props.modalTitle : 'Error'}</h3>
              </div>
              <div className="modal-content">
                {this.props.modalVoucherCode && (
                  <p className="modal-voucher-code">{this.props.modalVoucherCode}</p>
                )}
                {this.props.modalMessage && (
                  <p className="modal-copy">{this.props.modalMessage}</p>
                )}
              </div>
                <div className="modal-button-container is-column small-btns">
                  <div className="btn-container">
                    <button
                        className="btn btn-secondary modal-cancel-button"
                        onClick={() => {this.handleModalCancel()}}
                        >
                          {this.props.modalSecondaryCTAText}
                    </button>
                    <button
                        className="btn btn-primary modal-confirm-button"
                        onClick={() => {this.handleModalConfirm()}}
                        >
                        {this.props.modalMainCTAText}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </SwipeableContainer>
      </>
    );
  }
}

export default withAppState(Modal,
  {
    mobXProps: ({
      modalActive,
      modalTitle,
      modalVoucherCode,
      modalMessage,
      modalSecondaryCTAText,
      modalMainCTAText,
    }) => ({
      modalActive,
      modalTitle,
      modalVoucherCode,
      modalMessage,
      modalSecondaryCTAText,
      modalMainCTAText,
    }),
    mobXActions: ({ 
      mainModalCTA,
      disableMainModal,
    }) => ({
      mainModalCTA,
      disableMainModal,
    })
  }
);